import FormControl from '@mui/material/FormControl'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import React from 'react'

import { capitalizeFirstLetter } from '@/app/module/campaigns/helpers'

import { SpacingContainer, StyledFormControlLabel } from './common'

export type Props = {
  selectedAnswer?: string
  validAnswers: string[]
  onAnswerChange: (answer: string) => void
}

const CatiAnswerSingle: React.FC<Props> = ({ selectedAnswer, validAnswers, onAnswerChange }) => (
  <SpacingContainer spacing={2}>
    <FormControl variant="standard">
      <RadioGroup name="cati-single-select" value={selectedAnswer} onChange={(_, value) => onAnswerChange(value)}>
        {validAnswers.map((answer) => (
          <StyledFormControlLabel
            key={answer}
            control={<Radio />}
            label={capitalizeFirstLetter(answer)}
            value={answer}
          />
        ))}
      </RadioGroup>
    </FormControl>
  </SpacingContainer>
)

export default CatiAnswerSingle
